import _ from 'underscore';
import { odata } from '@bingads-webui/http-util';
import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';

const flightLogAPITemplate = '/ODataApi/Campaign/V2/Customers({CustomerId})/Accounts({AccountId})/PostABTestingFlightLog';
const eventLogAPITemplate = '/ODataApi/Campaign/V2/Customers({CustomerId})/Accounts({AccountId})/PostABTestingEventLog';

export const postABTestingFlightLog = (query) => {
  const config = DependencyResolver.get('component/config/index');
  const flightLogAPI = flightLogAPITemplate.replace('{AccountId}', config.get('CurrentAccount').Id).replace('{CustomerId}', config.get('CurrentCustomer').Id);
  return odata.post(flightLogAPI, _.extend({ data: { data: query } }));
};

export const postABTestingEventLog = (query) => {
  const config = DependencyResolver.get('component/config/index');
  const eventtLogAPI = eventLogAPITemplate.replace('{AccountId}', config.get('CurrentAccount').Id).replace('{CustomerId}', config.get('CurrentCustomer').Id);
  return odata.post(eventtLogAPI, _.extend({ data: { data: query } }));
};

export const ExperimentName = {
  MSANCampaignCreationFlowImporvement: 'MSANCampaignCreationFlowImporvement',
};
